import React from 'react';
import { View, Image, Text, StyleSheet, useWindowDimensions } from 'react-native';
import { useCustomImages } from '../../api/Brand';

// Largura da arte do aparelho: a bolha da notificação é medida a partir DELA,
// e não da tela. Antes era `screenWidth * 0.13`, lido uma única vez no import:
// no celular virava uma tira de ~50px, e nem reagia a resize.
const MOCKUP_WIDTH = 300;
const MOCKUP_HEIGHT = 600;

const MockupSmartphone = ({ title, content }) => {
  const { data: logo } = useCustomImages('logoApp');

  // No celular o aparelho inteiro é reduzido: em tamanho cheio ele sozinho
  // ocupa mais que a altura da tela, e a prévia — que existe justamente para
  // ser vista de relance — exigia rolar meia página.
  const { width: larguraTela } = useWindowDimensions();
  const escala = larguraTela < 768 ? 0.68 : 1;
  const px = (valor) => valor * escala;

  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString('pt-BR', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    timeZone: 'America/Sao_Paulo',
  });
  const formattedTime = currentDate.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'America/Sao_Paulo',
  });

  return (
    <View style={styles.container}>
      <Image
        source={require('../../../assets/mockupIOS.png')}
        style={[
          styles.phoneMockup,
          { width: px(MOCKUP_WIDTH), height: px(MOCKUP_HEIGHT), borderRadius: px(50) },
        ]}
      />
      <View style={[styles.dateTimeContainer, { top: px(35) }]}>
        <Text style={[styles.date, { fontSize: px(16) }]}>{formattedDate}</Text>
        <Text style={[styles.time, { fontSize: px(40) }]}>{formattedTime}</Text>
      </View>
      <View
        style={[
          styles.notification,
          { top: px(110), width: px(MOCKUP_WIDTH * 0.8) },
        ]}
      >
        <Image
          style={{ width: px(40), height: px(40) }}
          source={{
            uri: logo?.url,
          }}
        />
        <View style={styles.textContainer}>
          <Text style={styles.title}>{title}</Text>
          <Text style={styles.message}>{content}</Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  // Sem `flex: 1`: dentro de um ScrollView isso fazia a caixa ser medida pela
  // altura visível da tela, e não pela arte que ela contém.
  container: {
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  phoneMockup: {
    backgroundColor: 'gray',
  },
  notification: {
    position: 'absolute',
    padding: 10,
    backgroundColor: '#fff',
    borderRadius: 6,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.8,
    shadowRadius: 2,
    elevation: 5,
    flexDirection: 'row',
    // Não escala junto: o texto da notificação continua no tamanho de leitura,
    // e a bolha precisa caber nele.
    minHeight: 80,
    alignItems: 'center',
  },
  textContainer: {
    paddingLeft: 6,
    flex: 1,
  },
  title: {
    fontWeight: 'bold',
    fontSize: 12,
    flexShrink: 1,
    flexWrap: 'wrap',
  },
  message: {
    fontSize: 12,
    flexShrink: 1,
    flexWrap: 'wrap',
  },
  dateTimeContainer: {
    position: 'absolute',
    alignItems: 'center',
    width: '100%',
  },
  time: {
    fontWeight: 'bold',
    color: '#fff',
  },
  date: {
    color: '#fff',
    marginTop: 6,
  },
});

export default MockupSmartphone;
